/* tslint:disable */
/* eslint-disable */
export enum Type {
  Linear = 'linear',
  Ondemand = 'ondemand',
  Adv = 'adv'
}
